module.exports = __webpack_public_path__ + "img/parties.bb75deb3.jpg";